/**
 * Language switcher
 * The switcher is a native <details> element, so it opens, closes and is
 * keyboard-operable without this script. This only adds the two behaviours
 * <details> lacks: closing when the user clicks outside it, and closing on
 * Escape (restoring focus to the toggle).
 *
 * @package StandOut
 * @since 2.0.0
 */
import { $, $$ } from "@utils/dom";
export const initLanguageSwitcher = () => {
    const switchers = $$("[data-language-switcher]");
    if (switchers.length === 0) {
        return;
    }
    document.addEventListener("click", (event) => {
        const target = event.target;
        switchers.forEach((switcher) => {
            if (switcher.open && target && !switcher.contains(target)) {
                switcher.open = false;
            }
        });
    });
    document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") {
            return;
        }
        switchers.forEach((switcher) => {
            if (switcher.open) {
                switcher.open = false;
                $("summary", switcher)?.focus();
            }
        });
    });
};
